// operation_controller.js
import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["checkbox", "createForm", "orderIdsContainer"]

  createLot() {
    this.orderIdsContainerTarget.innerHTML = ""
    ;[...document.querySelectorAll(".order-checkbox:checked")].forEach(cb => {
      const input = document.createElement("input")
      input.type = "hidden"
      input.name = `${this.element.dataset.formResource}[order_ids][]`
      input.value = cb.value
      this.orderIdsContainerTarget.appendChild(input)
    })
    this.createFormTarget.submit()
  }

  openCreateModal() {
    console.log(this.element)
    this.injectOrderIds("selected-order-ids", this.element.dataset.formResource)
    $("#createOperationModal").modal("show")
  }

  openAddModal() {
    this.injectOrderIds("add-order-ids", this.element.dataset.formResource)
    $("#addOperationModal").modal("show")
  }

  injectOrderIds(containerId, formResource) {
    const orderIds = [...document.querySelectorAll(".order-checkbox:checked")]
                       .map(cb => cb.value)
    console.log('inject')
    console.log(orderIds)
    console.log(formResource)
    const container = document.getElementById(containerId)
    container.innerHTML = ""

    orderIds.forEach(id => {
      const input = document.createElement("input")
      input.type = "hidden"
      input.name = `${formResource}[order_ids][]`
      input.value = id
      container.appendChild(input)
    })
  }

  toggleAll(event) {
    document.querySelectorAll(".order-checkbox").forEach(cb => {
      cb.checked = event.target.checked
    })
    this.updateButtons()
  }

  exportSelected(event) {
    const ids = [...document.querySelectorAll(".order-checkbox:checked")].map(cb => cb.value)
    const url = event.currentTarget.dataset.exportUrl
    const params = ids.map(id => `order_ids[]=${id}`).join("&")
    window.location = `${url}?${params}`
  }

  updateButtons() {
    const anyChecked = document.querySelectorAll(".order-checkbox:checked").length > 0
    document.getElementById("create-operation-btn").disabled = !anyChecked
    document.getElementById("export-selected-btn").disabled = !anyChecked
    //document.getElementById("add-to-operation-btn").disabled = !anyChecked
  }
}